@if (data.isAvailable && data.showAIButton) {
  <button class="ai-fill-button" title="{{ data.label !== undefined ? data.label : '' }}" (click)="textToSpeech()">
    <img class="bot-icon" src="assets/images/icons/ai_1.svg">
  </button>
}
<ng-template #customComponent></ng-template>